import { VCheckbox } from 'vuetify/lib/components/VCheckbox';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCheckbox,{attrs:{"disabled":_vm.loading,"color":"green"},on:{"change":_vm.paymentConfirm},model:{value:(_vm.order.payment.confirmed),callback:function ($$v) {_vm.$set(_vm.order.payment, "confirmed", $$v)},expression:"order.payment.confirmed"}})}
var staticRenderFns = []

export { render, staticRenderFns }